import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { buttonVariants } from "@/components/ui/button";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" noindex />
      <section className="container grid min-h-[50vh] place-items-center py-20 text-center">
        <div>
          <p className="text-5xl font-bold text-brand-200">404</p>
          <h1 className="mt-2 text-2xl font-bold">Page not found</h1>
          <p className="mt-2 text-brand-600">
            The page you are looking for does not exist or has moved.
          </p>
          <Link to="/" className={cn(buttonVariants({ variant: "default" }), "mt-6 w-full justify-center sm:w-auto")}>
            Back home
          </Link>
        </div>
      </section>
    </>
  );
}
